import {
  EisPermission,
  LpPermission,
  CommonPermission,
  RolePermission,
} from 'further-types/admin-user-role';

export type FormData = {
  name: string;
  description: string;
  firmId?: string;
  permissions: Array<RolePermission>;
};

export type PermissionGroupItem = {
  id?: string;
  requiresId?: string;
  permissions: Array<RolePermission>;
  label: string;
  description?: string;
};

export type PermissionGroup = {
  groupName: string;
  groupDescription: string;
  autoEnabled?: boolean;
  groupItems: Array<PermissionGroupItem>;
};

const lpPermissionValues = new Set<string>([
  ...Object.values(LpPermission),
  ...Object.values(CommonPermission),
]);
const eisPermissionValues = new Set<string>([
  ...Object.values(EisPermission),
  ...Object.values(CommonPermission),
]);

export const isLpPermission = (
  p: RolePermission,
): p is LpPermission | CommonPermission => lpPermissionValues.has(p);

export const isEisPermission = (
  p: RolePermission,
): p is EisPermission | CommonPermission => eisPermissionValues.has(p);
